import React from 'react';
import PropTypes from 'prop-types';

import CourseList from './CourseList';
import PlayersList from './Player/PlayersList';
import Titlebar from '../../../components/Titlebar';
import {NavbarSearchPropTypes, CoursePropTypes, CreateGameFormPropTypes, PlayerMinimalPropType, createUserInfoPropType}
    from "../../../utils/propTypes";

const CreateGameComponent = ({
    courses, loadingIndicator, selectCourse, search, form, players, selectPlayer, goBack, disableStartingGame,
    startGame, onOpenSearch, activeTab, onClearSearch, onSearch, showLoadingIndicator, createUser, createNewUserForm,
    onAddNewUserButtonClick, onCreateNewUserFormHideForm,
}) => {
    let title = 'SELECT COURSE';
    let showAddNewButton = false;

    let renderedComponent = (<CourseList
        courses={courses}
        selectCourse={selectCourse}
        search={search}
        loadingIndicator={loadingIndicator}
    />);

    if (activeTab === 'PLAYERS') {
        renderedComponent = (<PlayersList
            form={form}
            players={players}
            selectPlayer={selectPlayer}
            goBack={goBack}
            startGame={startGame}
            disableStartingGame={disableStartingGame}
            search={search}
            createUser={createUser}
            createNewUserForm={createNewUserForm}
            onCreateNewUserFormHideForm={onCreateNewUserFormHideForm}
            clearSearch={onClearSearch}
        />);
        showAddNewButton = true;
        title = 'SELECT PLAYERS';
    }

    const titlebar = (<Titlebar
        title={title}
        onOpenSearch={onOpenSearch}
        search={search}
        activeTab={activeTab}
        onSearch={onSearch}
        onClearSearch={onClearSearch}
        showLoadingIndicator={showLoadingIndicator}
        showAddNewButton={showAddNewButton}
        onAddNewUserButtonClick={onAddNewUserButtonClick}
    />);

    return (
        <div>
            {titlebar}
            {renderedComponent}
        </div>
    );
};

CreateGameComponent.propTypes = {
    courses: PropTypes.arrayOf(CoursePropTypes),
    selectCourse: PropTypes.func.isRequired,
    search: NavbarSearchPropTypes,
    form: CreateGameFormPropTypes,
    players: PropTypes.arrayOf(PlayerMinimalPropType),
    selectPlayer: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    disableStartingGame: PropTypes.bool.isRequired,
    startGame: PropTypes.func.isRequired,
    onOpenSearch: PropTypes.func.isRequired,
    activeTab: PropTypes.oneOf(['COURSE', 'PLAYERS']),
    onClearSearch: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    showLoadingIndicator: PropTypes.func.isRequired,
    loadingIndicator: PropTypes.bool.isRequired,
    createUser: PropTypes.func.isRequired,
    createNewUserForm: createUserInfoPropType,
    onAddNewUserButtonClick: PropTypes.func.isRequired,
    onCreateNewUserFormHideForm: PropTypes.func.isRequired,
};

export default CreateGameComponent;



// WEBPACK FOOTER //
// ./src/apps/create_game/components/CreateGameComponent.js